import type { DashboardMetric } from "../type";
import { SegmentsGroupMonthlyVisitsGraphWidget } from "./SegmentsGroupMonthlyVisitsGraphWidget";

export class SegmentsGroupTrafficShareGraphWidget extends SegmentsGroupMonthlyVisitsGraphWidget {
    protected metric: DashboardMetric;
    protected dataSource;

    constructor() {
        super();
        this.dataSource = "TrafficShare";
        this.metric = "SegmentsGroupTrafficShare";
    }

    static getWidgetDashboardType() {
        return "Graph";
    }

    static getWidgetResourceType() {
        return "Graph";
    }

    static getWidgetMetadataType() {
        return "SegmentsGroupTrafficShareGraph";
    }

    public getGraphData(transformedData) {
        return super.getGraphData(transformedData, this.metric);
    }
}

SegmentsGroupTrafficShareGraphWidget.register();
